module.exports = __webpack_public_path__ + "assets/img/pushHouse.fd590d7c.svg";